import { AxiosResponse } from 'axios';

import { api } from '../../http';
import { LicenseDto } from '../../types/interfaces';

export const LicenseService = {
  getLicense(): Promise<AxiosResponse<LicenseDto>> {
    return api.get<LicenseDto>('License');
  }
};


